function notice () {
    /**
     * Настройка отображения окна оповещения на сайте
     */
    const notice = document.querySelectorAll('.notice');
    const noticeClose = document.querySelectorAll('.notice-close');

    noticeClose.forEach(el=> {
        el.addEventListener('click', (e)=> {
            e.preventDefault();

            notice.forEach(el=> el.classList.remove('show'));
            document.body.style.overflow = 'initial';
        });
    })

    document.addEventListener('click', (e)=> {
        if(e.target && e.target.classList.contains('notice')) {
            e.target.classList.remove('show');
            document.body.style.overflow = 'initial';
        }
    });
}

export default notice;